import classNames from 'classnames';
import { DetailedHTMLProps, FC, InputHTMLAttributes, memo } from 'react';

import styles from './ImageCropperSlider.style.m.css';

interface IImageCropperSliderProps
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  className?: string;
  value: number;
  min: number;
  max: number;
}

export const ImageCropperSlider: FC<IImageCropperSliderProps> = memo((props) => {
  const { name, value, max, min, step, onChange, className } = props;
  const filled = ((value - min) / (max - min)) * 100;

  return (
    <div className={styles.slider}>
      <div
        className={styles.dot}
        style={{ width: `${filled}%` }}
      />
      <input
        className={classNames(styles.input, className)}
        type="range"
        name={name}
        min={min}
        value={value}
        max={max}
        step={step}
        onChange={onChange}
      />
    </div>
  );
});
